import * as FindUserCreator from './findUser';
import * as ActivityCreator from './activity';
import * as CommunicationCreator from './communication';
import * as PaymentsCreators from './paymentsInfo';
import * as UserExplorerActions from '../actions/userExplorer';

import { ApplicationTab } from '../constants';

import ReduxAction from '../interfaces/ReduxAction';

export function onCalendarRefreshButtonClick (): ReduxAction {
  return (dispatch, getState): void => {
    if (getState().findUser.activeTab === ApplicationTab.User) {
      dispatch(FindUserCreator.findUser());
      dispatch(UserExplorerActions.fetchUserExplorerInitAction());
    } else if (getState().findUser.activeTab === ApplicationTab.Activity) {
      dispatch(ActivityCreator.activity());
      dispatch(UserExplorerActions.fetchUserExplorerInitAction());
    } else if (getState().findUser.activeTab === ApplicationTab.Communication) {
      dispatch(CommunicationCreator.communication());
      dispatch(UserExplorerActions.fetchUserExplorerInitAction());
    } else if (getState().findUser.activeTab === ApplicationTab.Payments) {
      dispatch(PaymentsCreators.payments());
      dispatch(UserExplorerActions.fetchUserExplorerInitAction());
    } else {
      return null;
    }
  };
}
